import { render, staticRenderFns } from "./Expert.vue?vue&type=template&id=bc363050&scoped=true"
import script from "./Expert.vue?vue&type=script&lang=js"
export * from "./Expert.vue?vue&type=script&lang=js"
import style0 from "./Expert.vue?vue&type=style&index=0&id=bc363050&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc363050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc363050')) {
      api.createRecord('bc363050', component.options)
    } else {
      api.reload('bc363050', component.options)
    }
    module.hot.accept("./Expert.vue?vue&type=template&id=bc363050&scoped=true", function () {
      api.rerender('bc363050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sidebar/Expert.vue"
export default component.exports